<!-- About us Start -->
<section class="section bg-light" id="about">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-6 col-md-8">
                <div class="title text-center mb-5">
                    <h3 class="font-weight-normal text-dark">Acerca de <span class="text-warning">Nosotros</span></h3>
                    <p class="text-muted">Conoce como nos definimos como empresa y cuáles valores nos exigen una mejora constante..</p>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-4">
                <h2 class="font-weight-light line-height-1_6 text-dark mb-4">Nos apaciona la creación de tecnologías que resuelvan sus necesidades.</h2>
            </div>
            <div class="col-md-7 offset-md-1">
                <div class="row">
                    <div class="col-md-6">
                        <h6 class="text-dark font-weight-light f-20 mb-3">Nuestra Misión</h6>
                        <p class="text-muted font-weight-light">Nuestra misión siempre será ofrecer un producto de calidad para solucionar las necesidades tecnológicas de nuestros clientes, sean estas necesidades las más comunes o las más <b>personalizadas</b>.</p>
                    </div>
                    <div class="col-md-6">
                        <h6 class="text-dark font-weight-light f-20 mb-3">Nuestra Visión</h6>
                        <p class="text-muted font-weight-light">Queremos ser un proveedor de confianza que investiga, estructura, desarrolla e implementa las soluciones mas complejas del mercado para cada cliente de forma personalizada o global.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- About us End -->